import angular from 'angular';
import Model from './model';

function MapFactory(Model) {
	return class BaseMap extends Model {
		constructor(dataModel) {
			super(new Map());
			this.model = dataModel;
		}
		fromCollection(collection) {
			this.data.clear();
			Object.keys(collection).forEach((key) => {
				this.data.set(key, new this.model(collection[key]));
			});
			this.setData();
			return this.data;
		}

		toCollection() {

		}

		toArray() {
			return Array.from(this.data.values()).map(val => val.data);
		}

		set(item) {
			this.data.set(item.id, item);
		}

		get(id) {
			return this.data.get(id)
		}
	}
}
MapFactory.$inject = ['Model'];

export default angular.module('maps.base', [Model])
	.factory('BaseMap', MapFactory)
	.name;



// WEBPACK FOOTER //
// ./project/models/map.js